export enum EScanpoolSource {
  VERSION = 'VERSION', DEVVERSION = 'DEVVERSION'
}
